import React, { Component } from "react";
import { StyleSheet, View, Text, PanResponder, Animated, PanResponderInstance, ViewStyle, StyleProp, PanResponderGestureState, Pressable,  } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";

export interface IDraggable
{
  style?  : StyleProp<ViewStyle>;
  iIndex? : number;

  manageScroll?(iMsg    : number,
                oParam? : any) : any;

  // handleScroll(bEnabled? : boolean) : void;
  // doScroll(bScrollY : number) : void;
  // getScrollPos() : number;
}

export default class Draggable extends Component<IDraggable> 
    {
    public static SCROLL_DISABLE = 0;
    public static SCROLL_ENABLE  = 1;
    public static SCROLL_GET_POS = 2;
    public static SCROLL_GO_TO   = 3;

    private _val = {x: 0, y: 0};
    private _gesture? : PanResponderGestureState;
    private _top = 0;

    state = 
    {
    showDraggable: true,
    dropAreaValues: null,
    oY: new Animated.Value(0),
    scaleY: new Animated.Value(2),
    scrollX: new Animated.Value(50),
    pan: new Animated.ValueXY(),
    opacity: new Animated.Value(1)
    };

    private panResponder : PanResponderInstance;
    
    _handleOnPanResponderMove(e, gestureState : PanResponderGestureState) {
        // some calculations - seems to be correct since everything is working fine until I swipe very fast
        // if (reachedBorders(...)) { // this takes into account also the direction so it won't get stuck on the border
        //     return true
        // }

      return Animated.event([null, { dx: this.state.pan.x, dy: this.state.pan.y, }], {useNativeDriver: false}, )(e, gestureState)
    }

    constructor(props) 
    {
    super(props);
  
    // this._handleOnPanResponderMove = this._handleOnPanResponderMove.bind(this);

    //this._val = { x:0, y:0 }
    this.state.pan.addListener((value) => 
        {
        this._val = value
         console.log(this._val);

        // if (value.y > 200)
        //   {
        //   this.props.doScroll(this._val.y);
        //   this.state.scaleY.setValue(2);
        //   }
        // else
        //   this.state.scaleY.setValue(1);
        // 
       });
  
    this.panResponder = PanResponder.create({
          
          onStartShouldSetPanResponder: (e, gesture) => true,
          onStartShouldSetPanResponderCapture: (evt, gestureState) => true,

          onMoveShouldSetPanResponder: (e, gesture) => {
            //if (gesture?.moveX > gesture?.moveY) {
             // return false;
           // }

            // console.log("move: " + gesture?.moveY);
            // if (gesture?.moveY > 100)
            // return false;
            // else
            return true;
          },
          
          onMoveShouldSetPanResponderCapture: (evt, gestureState) => true,

          //onPanResponderTerminate: (e, gesture) => {},

          //onShouldBlockNativeResponder: (e, gesture) => {return(false)},

          onPanResponderTerminationRequest: (e, gesture) => 
          {
            // let toval = Math.round(this._val.y/70) * 70;
            // console.log("y=" + this._val.y + " rounded: " + toval);

            // this.state.pan.flattenOffset();
            // this._val.y = 0;
            // this._val.x = 0;
            
            // Animated.timing(this.state.pan, {
            //   toValue: {x:0, y:toval},
            //   duration: 100,
            //   useNativeDriver:true
            // }).start(()=>{      });

            return(false);
          },

          onPanResponderGrant: (e, gesture) => {

            //this.props.handleScroll(false);
            this.props.manageScroll??(Draggable.SCROLL_DISABLE);

            console.log("grant: " + this._val.y);
            //this._val.y = 0;

            this.state.pan.setOffset({
              x: this._val.x,
              y: this._val.y
            });

            // this.state.pan.setOffset({
            //     x: 0,
            //     y: 0
            //   });
  
          //this.state.pan.flattenOffset();

          this.state.pan.setValue({ x:0, y:0});

          //this._top = this.props.getScrollPos();
          if (this.props.manageScroll)
            this._top = this.props.manageScroll(Draggable.SCROLL_GET_POS);

         // this.state.pan.extractOffset();
          //this.state.pan.flattenOffset();
          },

        //  onPanResponderMove: this._handleOnPanResponderMove.bind(this),

          //  onPanResponderMove: Animated.event(
          //    [null, { dx: this.state.pan.x, dy: this.state.pan.y, }, ], 
          //  )
          //  ,

          onPanResponderMove: (e, gesture) => {
            //
            // Set value of state.animate x/y to the
            // delta value of each
            //
            //let top = this.props.getScrollPos();

            let iTop = this.props.manageScroll? this.props.manageScroll(Draggable.SCROLL_GET_POS) : 0;

            this.state.pan.setValue({
              x: gesture.dx,
              y: this._top == iTop? gesture.dy : gesture.dy
            });

            //this.props.doScroll(this._top + gesture.dy);

            this.props.manageScroll??(Draggable.SCROLL_GO_TO, this._top + gesture.dy);

            //this._top = this.props.getScrollPos();
          },
          
          onPanResponderRelease: (e, gesture) => {
              //this.props.handleScroll(true);
              this.props.manageScroll??(Draggable.SCROLL_ENABLE);

              let toval = Math.round(this._val.y/70) * 70;
              console.log("y=" + this._val.y + " rounded: " + toval);

              this.state.pan.flattenOffset();
              this._val.y = 0;
              this._val.x = 0;
              
              this.state.pan.setValue({x:0, y:toval});
              // Animated.timing(this.state.pan, {
              //   toValue: {x:0, y:toval},
              //   duration: 100,
              //   useNativeDriver:true
              // }).start(()=>{      });

            //this.state.pan.setValue({ x:0, y:toval});
            // if (this.isDropArea(gesture)) {
            //   Animated.timing(this.state.opacity, {
            //     toValue: 0,
            //     duration: 1000,
            //     useNativeDriver:true
            //   }).start(() =>
            //     this.setState({
            //       showDraggable: false
            //     })
            //   );
            // } 
          }
        });
    }
  

    isDropArea(gesture) {
      this._gesture = gesture;

      return true;
    }
  
    render() {
      return (
        <>
          {this.renderDraggable()}
        </>
      );
    }

    renderDraggable() {
        
        //let a = this.state.pan.getLayout();

        //const scrollYPosition = new Animated.Value(Number(JSON.stringify(this.state.pan.y)))
        //console.log("=>" + this.state.pan.y._value);
        //console.log("render");

        const panStyle = {
          transform: [{ translateX: this.state.pan.x}, {translateY: this.state.pan.y,  }, ]  //this.state.pan.getTranslateTransform()
        }
        if (this.state.showDraggable) {
          return (
              
               <View
                 {...this.panResponder.panHandlers}
                 style={[this.props.style, {opacity:1}]}
                 >

                {this.props.children}
                 {/* <Text>Hi</Text> */}
                   {/* <Text>{this._gesture?.moveX + "." + this._gesture?.moveY}</Text> */}
                   {/* <View style={{width:'100%', height:'100%'}}></View> */}
                   {/* <TouchableOpacity style={{backgroundColor:'red', width:40, height:20}} onPress={()=>{

              //     Animated.timing(this.state.pan, {
              //       toValue: {x:0, y:70},
              //       duration: 100,
              //       useNativeDriver:true
              //     }).start(()=>{      });


              //     }}><Text> Press  </Text></TouchableOpacity> */}
              </View>
          );
        }
      else
        return(null);
      }
    }